const zipValidator = (message = "Invalid format") => function(value, state) {
  if (value && value.length < 5 || (value.length > 5 && value.length < 9) || value.length > 9) {
    return message;
  }

  return null;
};

export default zipValidator;
